import { Box } from '@warp-ds/react/components/box';

export interface InfoBoxProps {
    title: string;
    main: string;
    description: string | JSX.Element;
    updated: string;
}

export const InfoBox = ({ title, main, description, updated }: InfoBoxProps) => (
    <Box info className="mb-16 flex flex-col w-full md:w-[320px]">
        <p className="t5 md:t4 font-bold">{title}</p>
        <p className="t4 md:t3 font-bold mt-8">{main}</p>
        <p className="text-body mt-8">{description}</p>
        <p className="text-detail mt-auto">{updated}</p>
    </Box>
);
